import Vue from "vue";
import BrowserLogger from "alife-logger";
import { version } from "../../package.json";

/** 开发环境不做打点上报 */
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_LOGGER !== "local"
) {
  const __bl = BrowserLogger.singleton({
    pid: "eg0azz190g@29f5591d5901edd",
    release: `${process.env.VUE_APP_GAME_CODE}-${process.env.VUE_APP_ACT_CODE}`,
    tag: version,
    environment: process.env.VUE_APP_LOGGER,
    sendResource: true, // 上报页面静态资源
    useFmp: true, // 采集首屏FMP（First Meaningful Paint，首次有效渲染）数据
    ignore: {
      // 符合以下规则的 JS 错误不会被上报
      ignoreErrors: ["Network Error", "已取消", /^Script error\.?$/],
      // 忽略所有内联的资源错误
      ignoreResErrors: [
        function(str) {
          if (str && str.includes("//act.jzyx.com")) return true; // 不上报
          return false; // 上报
        }
      ]
    }
  });

  Vue.prototype.$bl = __bl;
}
